import React from 'react'
import { Link } from 'react-router-dom'
import { Card, CardBody, Col, Row ,  Media, CardTitle,} from 'reactstrap'
import WelcomeComp from '../../pages/Dashboard/WelcomeComp'

const DashboardForStoreManager = (props) => {

  let store_type = localStorage.getItem("store_type")
//  POE (Place Order Equipment)
//  AOE (All Order Equipment)
//  POI (Place Order Item)
//  AOI (All Order Item)
//  AIR (All Item Request)
  const  getRouteLink = (type,status) =>{
   let pageLink = ""
    if(status==="POE"){
        switch(type) {
            case "Main Store" :
            pageLink = "/equipments/add_orders/mainstore";
            break;
            case "Sub Store" :
            pageLink = "/equipments/add_orders/substore";
             break;
        }
    }
    else if(status==="AOE"){
        switch(type) {
            case "Main Store" :
            pageLink = "/equipments/all_orders/mainstore";
            break;
            case "Sub Store" :
            pageLink = "/equipments/all_orders/substore";
             break;
        }
    }
    else if(status==="POI"){
        switch(type) {
            case "Main Store" :
            pageLink = "/items/add_new_order/from/main";
            break;
            case "Sub Store" :
            pageLink = "/items/add_new_order";
             break;
        }
    }
    else if(status==="AOI"){
        switch(type) {
            case "Main Store" :
            pageLink = "/items/all_orders/to/main";
            break;
            case "Sub Store" :
            pageLink = "/items/all_orders/to/substore";
             break;
        }
    }
    else if(status==="AIR"){
        switch(type) {
            case "Main Store" :
            pageLink = "/items/allItemRequests/to_main";
            break;
            case "Sub Store" :
            pageLink = "/items/allItemRequests/to_substore";
             break;
        }
    }
    return pageLink;
  }
  

  return (
    <>

        
      <Row>
      <Col md="6">
                  <WelcomeComp />
                </Col>
                      <Col xl={12}>
                        <CardTitle>Equipments</CardTitle>
                        <div
                          style={{
                            height: "90px",
                            overflowX: "hidden",
                            overflowY: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Link
                            to={()=>getRouteLink(store_type,"POE")}
                            style={{ display: "inline-block" }}
                          >
                            <Card
                              className={
                                props.type === "new_orders"
                                  ? "mini-stats-wid bg-danger mr-4"
                                  : props.type === "orders_in_process"
                                    ? "mini-stats-wid bg-info mr-4"
                                    : "mini-stats-wid bg-success mr-4"
                              }
                              style={{ width: "180px" }}
                            >
                              <CardBody>
                                <Media>
                                  <Media body>
                                   
                                    <h5
                                      className="mb-0"
                                      style={{ color: "white" }}
                                    >
                                      Add New Order
                                    </h5>
                                  </Media>
                                </Media>
                              </CardBody>
                            </Card>
                          </Link>
                          <Link
                            to={getRouteLink(store_type,"AOE")}
                            style={{ display: "inline-block" }}
                          >
                            <Card
                              className={
                                props.type === "new_orders"
                                  ? "mini-stats-wid bg-danger mr-4"
                                  : props.type === "orders_in_process"
                                    ? "mini-stats-wid bg-info mr-4"
                                    : "mini-stats-wid bg-success mr-4"
                              }
                              style={{ width: "180px" }}
                            >
                              <CardBody>
                                <Media>
                                  <Media body>
                                    {/* <p
                                className="fw-medium"
                                style={{ color: "white" }}
                              >
                                {section.section}
                              </p> */}
                                    <h5
                                      className="mb-0"
                                      style={{ color: "white" }}
                                    >
                                      View All Order
                                    </h5>
                                  </Media>
                                </Media>
                              </CardBody>
                            </Card>
                          </Link>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <CardTitle>Items</CardTitle>
                        <div
                          style={{
                            height: "90px",
                            overflowX: "hidden",
                            overflowY: "hidden",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <Link
                            to={getRouteLink(store_type,"POI")}
                            style={{ display: "inline-block" }}
                          >
                            <Card
                              className={
                                props.type === "new_orders"
                                  ? "mini-stats-wid bg-danger mr-4"
                                  : props.type === "orders_in_process"
                                    ? "mini-stats-wid bg-info mr-4"
                                    : "mini-stats-wid bg-success mr-4"
                              }
                              style={{ width: "180px" }}
                            >
                              <CardBody>
                                <Media>
                                  <Media body>
                                   
                                    <h5
                                      className="mb-0"
                                      style={{ color: "white" }}
                                    >
                                      Add New Order
                                    </h5>
                                  </Media>
                                </Media>
                              </CardBody>
                            </Card>
                          </Link>
                          <Link
                            to={getRouteLink(store_type,"AOI")}
                            style={{ display: "inline-block" }}
                          >
                            <Card
                              className={
                                props.type === "new_orders"
                                  ? "mini-stats-wid bg-danger mr-4"
                                  : props.type === "orders_in_process"
                                    ? "mini-stats-wid bg-info mr-4"
                                    : "mini-stats-wid bg-success mr-4"
                              }
                              style={{ width: "180px" }}
                            >
                              <CardBody>
                                <Media>
                                  <Media body>
                                   
                                    <h5
                                      className="mb-0"
                                      style={{ color: "white" }}
                                    >
                                      View All Order
                                    </h5>
                                  </Media>
                                </Media>
                              </CardBody>
                            </Card>
                          </Link>
                          <Link
                            to={getRouteLink(store_type,"AIR")}
                            style={{ display: "inline-block" }}
                          >
                            <Card
                              className={
                                props.type === "new_orders"
                                  ? "mini-stats-wid bg-danger mr-4"
                                  : props.type === "orders_in_process"
                                    ? "mini-stats-wid bg-info mr-4"
                                    : "mini-stats-wid bg-success mr-4"
                              }
                              style={{ width: "180px" }}
                            >
                              <CardBody>
                                <Media>
                                  <Media body>
                                   
                                    <h5
                                      className="mb-0"
                                      style={{ color: "white" }}
                                    >
                                      All Requests
                                    </h5>
                                  </Media>
                                </Media>
                              </CardBody>
                            </Card>
                          </Link>
                        </div>
                      </Col>
                    </Row>

   
    </>
  )
}

export default DashboardForStoreManager